import type { RouteObject } from 'react-router';

import { searchEventsRouteObjects } from '#/modules/search/events/routing/searchEvents.route-objects';
import { searchInternshipsRouteObjects } from '#/modules/search/internships/routing/searchInternships.route-objects';
import { searchJobsRouteObjects } from '#/modules/search/jobs/routing/searchJobs.route-objects';
import { searchOrgsRouteObjects } from '#/modules/search/orgs/routing/searchOrgs.route-objects';
import * as savedSearchRedirectHorizonRouteExports from '#/modules/search/pages/SavedSearchRedirect/SavedSearchRedirect.horizon-route';
import { searchVolopsRouteObjects } from '#/modules/search/volops/routing/searchVolops.route-objects';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { redirectToSavedSearchRoute } from './search.routes';

export const searchRouteObjects = [
  {
    path: redirectToSavedSearchRoute.fullPath,
    ...horizonRouteToObject(savedSearchRedirectHorizonRouteExports),
  },

  ...searchJobsRouteObjects,
  ...searchInternshipsRouteObjects,
  ...searchVolopsRouteObjects,
  ...searchEventsRouteObjects,
  ...searchOrgsRouteObjects,
] satisfies RouteObject[];
